export default "__VITE_ASSET__KwPPreoR__"